/**
 * Sticky Status Bar — shows bundle progress from real Shopify cart.
 */
(function () {
  'use strict';

  function getProgressColor(count, target) {
    if (target === 5) {
      if (count <= 1) return '#C41E3A';
      if (count <= 2) return '#e67e22';
      if (count <= 3) return '#f1c40f';
      if (count <= 4) return '#a8d65c';
      return '#22c55e';
    }
    if (count <= 2) return '#C41E3A';
    if (count <= 5) return '#e67e22';
    if (count <= 8) return '#f1c40f';
    if (count <= 9) return '#a8d65c';
    return '#22c55e';
  }

  function update(cart) {
    var bar = document.getElementById('sticky-status-bar');
    var text = document.getElementById('sticky-status-text');
    var fill = document.getElementById('sticky-progress-fill');
    var link = document.getElementById('sticky-status-link');
    var checkoutLink = document.getElementById('sticky-status-checkout');

    if (!bar) return;

    var targetSize = window.BundleManager.getTargetSize();

    // Hide if no target size set, no cart, or cart contains only gift cards
    if (!targetSize || !cart || window.BundleManager.isGiftCardOnly(cart)) {
      bar.style.display = 'none';
      document.body.classList.remove('has-sticky-status-bar');
      document.documentElement.style.setProperty('--sticky-bar-height', '0px');
      return;
    }

    bar.style.display = 'block';
    document.body.classList.add('has-sticky-status-bar');
    // Dynamically push content below the bar (handles variable bar height on mobile)
    requestAnimationFrame(function () {
      var h = bar.offsetHeight;
      document.documentElement.style.setProperty('--sticky-bar-height', h + 'px');
    });

    var count = cart.item_count || 0;
    var total = cart.total_price || 0;
    var color = getProgressColor(count, targetSize);
    var isComplete = count === targetSize;
    var priceStr = window.BundleManager.formatMoney(total);

    // Progress bar
    var pct = Math.min(Math.round((count / targetSize) * 100), 100);
    if (fill) {
      fill.style.width = pct + '%';
      fill.style.backgroundColor = color;
    }

    // Text
    if (text) {
      if (isComplete) {
        text.textContent = targetSize + '-item bundle complete! — ' + priceStr;
      } else if (count > 0) {
        var remaining = targetSize - count;
        text.textContent = 'Building ' + targetSize + '-item bundle: ' + count + '/' + targetSize + ' — ' + remaining + ' more — ' + priceStr;
      } else {
        text.textContent = 'Building ' + targetSize + '-item bundle: 0/' + targetSize;
      }
    }

    // Continue building link
    if (link) {
      link.href = '/pages/build-a-collection?size=' + targetSize;
      link.style.display = isComplete ? 'none' : 'inline-block';
    }

    // View cart link (when complete)
    if (checkoutLink) {
      checkoutLink.style.display = isComplete ? 'inline-block' : 'none';
    }
  }

  // Listen for cart updates from BundleManager
  document.addEventListener('cart:updated', function (e) {
    update(e.detail);
  });

  document.addEventListener('DOMContentLoaded', function () {
    window.BundleManager.getCart().then(update);
  });
})();
